import {
  _LOGIN_SUCCESS,
  _LOGIN_FAILED,
  _LOGOUT,
  _GET_SHOP_CREDIT,
  _UPDATE_USER_DATA,
  _UPDATE_USER_WALLET_BALANCE,
  _UPDATE_USER_ROLLOVER_BALANCE,
  _UPDATE_USER_SPECIAL_ROLLOVER,
  _UPDATE_USER_LOYALTY_POINTS,
  _UPDATE_USER_IS_CREATE_SHARE_HOLDER_PIN
} from "./AuthAction";

const _INITIAL_STATE = {
  userData: {},
  isLoggedIn: false,
  loginMessage: "",
  loginStateInitialized: false,
  creditLimit: 0,
};

/// <summary>
/// Author :
/// </summary>
export default (state = _INITIAL_STATE, action) => {
  switch (action.type) {
    case _LOGIN_SUCCESS:
      return {
        ...state,
        userData: action.userData,
        isLoggedIn: true,
        loginMessage: "",
        loginStateInitialized: true,
      };
    case _LOGIN_FAILED:
      return {
        loginMessage: action.message,
        isLoggedIn: false,
        userData: {},
        loginStateInitialized: true,
      };
    case _UPDATE_USER_DATA:
      return {
        ...state,
        userData: action.userData,
      };
    case _GET_SHOP_CREDIT:
      return {
        ...state,
        creditLimit: action.creditLimit,
      };
    case _LOGOUT:
      return {
        userData: {},
        isLoggedIn: false,
        loginMessage: "",
        loginStateInitialized: true,
        creditLimit: 0,
      };
    case _UPDATE_USER_WALLET_BALANCE:
      return {
        ...state,
        userData: {
          ...state.userData,
          walletBalance: action.walletBalance,
        }
      };
    case _UPDATE_USER_ROLLOVER_BALANCE:
      return {
        ...state,
        userData: {
          ...state.userData,
          rolloverBalance: action.rolloverBalance,
        }
      };
    case _UPDATE_USER_SPECIAL_ROLLOVER:
      return {
        ...state,
        userData: {
          ...state.userData,
          isSpecialRollover: action.isSpecialRollover,
        }
      };
    case _UPDATE_USER_LOYALTY_POINTS:
      return {
        ...state,
        userData: {
          ...state.userData,
          loyaltyPoints: action.loyaltyPoints,
        }
      };
    case _UPDATE_USER_IS_CREATE_SHARE_HOLDER_PIN:
      return {
        ...state,
        userData: {
          ...state.userData,
          isCreateShareHolderPin: action.isCreateShareHolderPin,
        }
      };
    default:
      return state;
  }
};
